import React from 'react';

import { Box, Paper, Typography } from '@mui/material';

import { pluralize } from 'appUtils';

import styles from './RouteCountDisplay.module.css';

interface RouteCountDisplayProps {
  count: number;
}

export function RouteCountDisplay({ count }: RouteCountDisplayProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 8,
        left: 8,
        zIndex: 'var(--z-index-map-overlay)',
      }}
    >
      <Paper elevation={2} className={styles.paper}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {count} {pluralize(count, 'Route')} selected
        </Typography>
      </Paper>
    </Box>
  );
}
